/**
 * @desc 根据计划ID查询周计划概览
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanWeekOverviewResponse>>> {
  return defHttp.post({
    url: '/wap/plan/week/queryPlanOverview',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanWeekOverviewResponse>>> {
  return defHttp.post({
    url: '/mock/wap/plan/week/queryPlanOverview',
    data,
  });
}
